import { ORDER_INVOICE_LIST } from './invoiceTypes'
import { URL_INVOICE_LIST } from './invoiceUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
import axios from "../../axios";

export default {
    [ORDER_INVOICE_LIST]({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.get(URL_INVOICE_LIST, { params: params })
                .then((response) => {
                    let responseModel = new ResponseModel(response);
                    if (responseModel.status == STATUS_OK) {
                        let resultModel = responseModel.result;
                        if (resultModel.status == STATUS_OK) {
                            let data = resultModel.data;
                            commit(ORDER_INVOICE_LIST, data);
                            resolve(data);
                        } else {
                            commit(ORDER_INVOICE_LIST, { items: [], _links: {}, _meta: {} });
                            resolve({ items: [], _links: {}, _meta: {} });
                        }
                    } else {
                        commit(ORDER_INVOICE_LIST, { items: [], _links: {}, _meta: {} });
                        resolve({ items: [], _links: {}, _meta: {} });
                    }
                })
                .catch((error) => { reject(error) })
        })
    },
}
